module.exports = __webpack_public_path__ + "img/pay-success.b85620b8.png";